import { useEffect } from 'react';

const CAN_SEND = import.meta.env.VITE_IS_DEBUG === 'false';

const GTM_ID = import.meta.env.VITE_GTM_ID; // 環境変数からGTMのIDを取得

const GoogleTagManager = () => {
  useEffect(() => {
    // 開発環境では初期化しない
    if (!CAN_SEND) {
      console.log('GTM tracking is disabled in development');
      return;
    }

    if (!GTM_ID) {
      console.warn('GTM ID is missing');
      return;
    }

    // GTM スクリプトを動的に追加
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(script);

    // dataLayer の初期化
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'gtm_init' });

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
};

export default GoogleTagManager;
